const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();

let initialized = false;

export function initGtag() {
  if (!MEASUREMENT_ID || initialized) return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
    MEASUREMENT_ID
  )}`;
  document.head.appendChild(script);
}

export function sendPageView(pagePath) {
  if (!MEASUREMENT_ID || !initialized || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", "page_view", {
    page_path: pagePath,
    page_location: window.location.origin + pagePath,
    page_title: document.title,
  });
}
